import { Alert, AlertDescription, AlertIcon, Text } from '@chakra-ui/react';

import { formatCurrency } from 'app/utils/strings';

import { SalaryCutoffHoldProps } from './types';

const isHeld = (amount?: number): amount is number => amount !== undefined && amount > 0;

export function SalaryCutoffHoldNote({ amount, currency }: SalaryCutoffHoldProps) {
  if (!isHeld(amount)) {
    return null;
  }

  return (
    <Text
      textStyle="extraSmallRegular"
      color="brand.darkGray"
      data-testid="salary-cutoff-hold-note"
    >
      {formatCurrency(amount, currency)} held for salary cutoff
    </Text>
  );
}

export function SalaryCutoffHoldBanner({ amount, currency }: SalaryCutoffHoldProps) {
  if (!isHeld(amount)) {
    return null;
  }

  return (
    <Alert status="info" borderRadius="8px" data-testid="salary-cutoff-hold-banner">
      <AlertIcon />
      <AlertDescription>
        {formatCurrency(amount, currency)} of salary is held for a cutoff that hasn&apos;t booked
        yet. Balances shown exclude it.
      </AlertDescription>
    </Alert>
  );
}
